import { type EcrituresRewrite, KEPT_ECRITURES_RULE } from '@cpce/shared';
import { useState } from 'react';
import { Checkbox } from '@/components/Checkbox';
import { ConfirmModal } from '@/components/ConfirmModal';

interface TiersAccountChangeModalProps {
  title: string;
  tiers: 'salarié' | 'fournisseur';
  onConfirm: (moveEntries: boolean) => Promise<EcrituresRewrite>;
  closeModal: () => void;
}

/** Confirms relinking a salarié's 411 or a supplier's 401, and whether its history follows. */
export function TiersAccountChangeModal(props: TiersAccountChangeModalProps) {
  const { title, tiers, onConfirm, closeModal } = props;
  const [moveEntries, setMoveEntries] = useState(true);

  return (
    <ConfirmModal
      title={title}
      info={{
        title: 'Historique',
        text: moveEntries
          ? `Les écritures rattachées au ${tiers} (dossiers, règlements, factures) passent sur le nouveau compte, ainsi que les autres écritures de l'ancien compte s'il ne sert à personne d'autre. S'il est partagé, ces dernières y restent et sont signalées. ${KEPT_ECRITURES_RULE}`
          : "Les écritures déjà passées restent sur l'ancien compte ; seules les prochaines iront sur le nouveau.",
      }}
      onConfirm={() => onConfirm(moveEntries)}
      closeModal={closeModal}
    >
      <div className="flex items-center gap-2">
        <Checkbox
          id="move-tiers-history"
          checked={moveEntries}
          onCheckedChange={(checked) => setMoveEntries(checked === true)}
        />
        <label htmlFor="move-tiers-history" className="text-sm cursor-pointer">
          Déplacer aussi l'historique du {tiers} sur le nouveau compte
        </label>
      </div>
    </ConfirmModal>
  );
}
